import { FormControl, FormHelperText, InputLabel, MenuItem, Select, OutlinedInput } from '@mui/material';
import { useController } from 'react-hook-form';

const revisionOptions = [
  'Contract Exception',
  'Direct Competition',
  'Potential New Customer',
  'Previous Customer Expectation',
  'Recent price increase',
  'Negotiated Downward',
  'Customer refusal to accept price increase',
  'Rounded',
];
interface RevisionReasonFieldProps {
  name: `${string}` | `${string}.${string}` | `${string}.${number}`;
  label: string;
  defaultValue: string;
  rules?: Object;
  error?: boolean;
  helperText?: string;
  disabled?: boolean;
}
export function RevisionReasonField({
  name,
  defaultValue,
  rules,
  error,
  helperText,
  label,
  disabled,
}: RevisionReasonFieldProps) {
  const { field } = useController({
    name,
    rules,
    defaultValue,
  });

  return (
    <FormControl variant='outlined' fullWidth disabled={disabled}>
      <InputLabel id={`${name}-label`} shrink>
        {label}
      </InputLabel>
      <Select
        input={<OutlinedInput notched label={label} />}
        label={label}
        labelId={`${name}-label`}
        {...field}
        id={name}
        fullWidth
        error={error}
      >
        <MenuItem value=''>None</MenuItem>
        {revisionOptions.map(option => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
      {error && <FormHelperText error={error}>{helperText}</FormHelperText>}
    </FormControl>
  );
}
